require('angular');
require('angular-ui-router');
require('angular-utils-pagination');
require('angular-google-analytics');
require('./controllers');
require('./directives');

var app = angular.module('tristarApp', [
	'ui.router',
	'angularUtils.directives.dirPagination',
	'tristarApp.controllers',
	'tristarApp.directives',
	'angular-google-analytics'
])

app.config([
	'$stateProvider',
	'$urlRouterProvider',
	'$locationProvider',
	'AnalyticsProvider',
	function($stateProvider, $urlRouterProvider, $locationProvider, AnalyticsProvider) {

		// use the HTML5 History API
		$locationProvider.html5Mode({
			enabled: true,
			requireBase: false
		});

		$stateProvider
			.state('home', {
				url: '/',
				templateUrl: 'templates/home.html',
				controller: 'HomeController',
			})
			.state('products', {
				url: '/products',
				templateUrl: 'templates/products.html',
				controller: 'ProductsController',
			});

		$urlRouterProvider.otherwise("/");

		// analytics
		AnalyticsProvider.setAccount('UA-72866334-1');
		AnalyticsProvider
			.trackPages(true)
			.trackUrlParams(true)
			.setPageEvent('$stateChangeSuccess')
			.setDomainName('tristarwholesale.com');

	}
]);

app.run([
	'$rootScope',
	'$state',
	'$stateParams',
	'$http',
	'Analytics',
	function($rootScope, $state, $stateParams, $http, Analytics) {

		$rootScope.$state = $state;
		$rootScope.$stateParams = $stateParams;

		// set the post header content-type
		$http.defaults.headers.post["Content-Type"] = "application/json";
	}
]);

module.exports = app;



/*****************
 ** WEBPACK FOOTER
 ** ./js/app.js
 ** module id = 2
 ** module chunks = 0
 **/